import { render, staticRenderFns } from "./InDevelopmentInfo.vue?vue&type=template&id=410e6852"
import script from "./InDevelopmentInfo.vue?vue&type=script&lang=js"
export * from "./InDevelopmentInfo.vue?vue&type=script&lang=js"
import style0 from "./InDevelopmentInfo.vue?vue&type=style&index=0&id=410e6852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports